export function Noop() {
  return null;
}

Noop.attributes = [] as string[];
